import script from "./grades.vue?vue&type=script&setup=true&lang=js"
export * from "./grades.vue?vue&type=script&setup=true&lang=js"

import "./grades.vue?vue&type=style&index=0&id=45e2e273&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e2e273"]])

export default __exports__